export default __webpack_public_path__ + "static/media/lieferheld_l2.b0a4bb0a.png";